

export const showModal = payload => ({
    type: 'SHOW_MODAL',
    payload
});

export const hideModal = payload => ({
    type: 'HIDE_MODAL',
    payload
});

const INITIAL_STATE = {
    showModal: false,
    title: '',
    text: '',
    icon: null,
    timer: 5000,
    timerProgressBar: true,
    showConfirmButton: true,
    showCancelButton: false,
    onClose: () => true
};

export const modalReducer = (state = INITIAL_STATE, action) => {

    const {
        type, payload
    } = action;

    switch (type) {
        case 'SHOW_MODAL':
            return {
                ...state,
                showModal: true,
                ...payload
            };

        case 'HIDE_MODAL':
            return INITIAL_STATE;

        default:
            return INITIAL_STATE;
    }
};
